// 繁体中文
const userModule = {
  user: "我的",
  userName: "姓名",
  userInfo: "用戶信息",
  phone: "電話",
  sex: "性別",
  updatePassword: "修改密碼",
  myOrder: "我的訂單",
  myCoupon:"優惠券",
  aboutService: "關於這個服務",
  rule1: "利用規約",
  rule2: "保護方針",
  returnLogin: "退出登錄",
  sex0: "保密",
  sex1: "男",
  sex2: "女",
  email: "郵箱",
};
export default userModule;